import { XIcon } from "@heroicons/react/solid";
import { openDB } from "idb";
import React, { useEffect, useState, useContext } from "react";
import Context from "../context/context"
import CustomDropDown from "./CustomDropDown"
import { v4 as uuidv4 } from "uuid";

export default function NewMenu({ close, brands, menus }) {

    const [menuName, setMenuName] = useState("");
    const [items, setItems] = useState([]);
    const [category, setCategory] = useState([]);
    const context = useContext(Context);
    const { updateUnSync, showWarning } = context;
    const [brandSelection, setBrandSelection] = useState({ selected: '', visible: false, options: [] })

    useEffect(() => {
        const getCategoryData = async () => {
            const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
            let tx = db.transaction("category", "readonly").objectStore("category");
            const categorydata = await tx.getAll();
            setCategory(categorydata);

            tx = db.transaction("item", "readonly").objectStore("item");
            const itemdata = await tx.getAll();
            setItems(itemdata);

            tx = db.transaction("brand", "readonly").objectStore("brand");
            const brandsData = await tx.getAll();
            const doc = {};
            if (brandsData?.length > 1) doc.options = brandsData;
            doc.selected = brandsData[0]?.brand_uuid;

            setBrandSelection(curr => ({ ...curr, ...doc }))
        }
        if (brands?.length)
            getCategoryData()
    }, [brands])

    const handelMenuAdded = async () => {

        if (!brandSelection?.selected)
            return showWarning({
                message: 'Select a brand',
                classname: 'active-red'
            })

        const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
        const tx = db.transaction("menu", "readwrite").objectStore("menu");
        let id = uuidv4()
        let obj = {
            IDENTIFIER: id,
            brand_uuid: brandSelection?.selected || '',
            category_and_items: category?.filter(c => c.brand_uuid === brandSelection?.selected).map((a, i) =>
            ({
                category_uuid: a.category_uuid,
                menu_category_sort_order: i,
                menu_items: items.filter(b => a.category_uuid === b.category_uuid).map((b, ib) => ({
                    item_uuid: b.item_uuid,
                    menu_item_addons: [],
                    menu_item_description: "",
                    menu_item_discount: b?.outlet_wise_item_details[0]?.other_details?.item_excluded_from_discount || "0",
                    menu_item_label: "",
                    menu_item_multi: [],
                    menu_item_price: "0",
                    menu_item_recommended: "N",
                    menu_item_sort_order: ib,
                    menu_item_status: b?.outlet_wise_item_details[0]?.other_details?.item_status || "0",
                    menu_item_uuid: 12345678,
                }))

            })),
            date: "",
            meal_uuid: "",
            menu_for: ["1", "2", "3"],
            menu_title: menuName,
            menu_type: ["0"],
            menu_uuid: id,
            outlet_uuid: localStorage.getItem("outlet_uuid"),
        }
        await tx.put(obj)
        await MenuSyncedOut(obj)

        close()
    }

    const MenuSyncedOut = async (data) => {

        const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
        const tx = db.transaction("unsynced_files", "readwrite").objectStore("unsynced_files");
        const time = Date.now().toString()
        const ndata = {
            ...data,
            RECON_TIME: time,
            IDENTIFIER: "menu-new:" + data.menu_uuid,
        };
        await tx.put(ndata)
        await handleReconciliation(ndata)
        updateUnSync()
    }

    const handleReconciliation = async (data) => {
        const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
        const tx = await db
            .transaction("reconciliation", "readwrite")
            .objectStore("reconciliation");
        const allReconRecords = await tx.getAll();

        const sectionsJsonExists = allReconRecords.find(
            (curr) => curr.IDENTIFIER === "menu"
        );
        if (sectionsJsonExists) {
            const sections = sectionsJsonExists?.details?.filter(
                (section) => section.menu_uuid !== data.menu_uuid
            );
            const editData = {
                ...sectionsJsonExists,
                details: [
                    ...sections,
                    {
                        menu_uuid: data.menu_uuid,
                        RECON_TIME: data.RECON_TIME,
                    },
                ],
            };
            await tx.put(editData);
        } else {
            const newdata = {
                IDENTIFIER: "menu",
                details: [
                    {
                        menu_uuid: data.menu_uuid,
                        RECON_TIME: data.RECON_TIME,
                    },
                ],
            };
            await tx.add(newdata);
        }
    };

    return (
        <div className='newCategory' onKeyDown={(e) =>
            e.key === "Enter" && menuName !== ""
                ? handelMenuAdded()
                : document.getElementById("catname").focus()
        }>
            <div className='newCatContainer'>
                <div className='newCatContainer_header'>
                    <h2>New Menu</h2>
                    <XIcon className='closeicon' onClick={close} />
                </div>
                <div className='newCatContainer2'>
                    <div className='cat-inp'>

                        {brandSelection?.options?.length > 1 ?
                            <CustomDropDown
                                label={'Select Brand'} // label to be shown above the select component
                                state={brandSelection} // recommanded format : {visiblity : Boolean, options: Array, selection: String}
                                setState={setBrandSelection}
                                onSelect={value => setBrandSelection(curr => ({ ...curr, visible: false, selected: value })) } // handles option selection
                                styles={{
                                    container: { position: 'unset', marginBottom: '10px' } // container style
                                }}
                                valueTargetKey={'brand_uuid'} // From state.options[], value to be stored in state.selection
                                labelTargetKey={'brand_name'} // From state.options[], value to display in options label
                            /> : ''}

                        <label htmlFor='catname'>Menu Name</label>
                        <input
                            value={menuName}
                            onChange={(e) => setMenuName(e.target.value)}
                            maxLength={15}
                            type='text'
                            id='catname'
                        />
                    </div>

                    <button disabled={menuName === ""} onClick={menuName !== "" ? () => handelMenuAdded() : () => { }}>Save</button>

                </div>
            </div>
        </div>
    );
}
